// Lore Core shared design tokens, fonts, typography (top-level for Module Federation)
import '@sequelae/lore-core/dist/styles/index.css';
import './index.css';

import('./bootstrap.tsx');
